import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const deleteCallerAddress = async (id: number): Promise<boolean> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation DeleteCallerAddress($id: Float!) {
        deleteCallerAddress(id: $id) {
          id
        }
      }
    `),
    variables: {
      id,
    },
  });

  return !!response.data?.deleteCallerAddress;
};
